import { useInfiniteQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { QUERY_KEY } from '../../constants'

import { getNoticeList } from '../../api/notice'

import { ColumnItem, CenterWrap } from '../../components/common'
import { Text } from '../../components/text'
import { Spinner } from '../../components/spinner/Spinner'
import { StyledLabel } from '../../components/label'
import { InfinityScroll } from '../../components/pagingList/InfinityScroll'
import { NotificationList, NotificationItem } from '../notification/components/List'

import { Color } from '../../theme/color'

export function MainNotice() {
  const { data, isPending, isError, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: [QUERY_KEY.noticeList],
    queryFn: async ({ pageParam = 0 }) => await getNoticeList({ offset: pageParam, size: 50 }),
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.offset + lastPage.size),
    initialPageParam: 0,
    select: (data) => ({
      ...data,
      pages: data.pages.map((page) => page.list).flat(),
    }),
  })

  if (isPending || isError) {
    return (
      <CenterWrap>
        <Spinner />
      </CenterWrap>
    )
  }

  return (
    <InfinityScroll length={data.pages.length} isLast={!hasNextPage} next={fetchNextPage}>
      <NotificationList>
        {data.pages.map(({ id, title, createdDate }) => {
          const isNew = dayjs().diff(dayjs(createdDate), 'day') + 1 < 8

          return (
            <Link key={id} to={`/notice/${id}`}>
              <NotificationItem>
                {isNew ? (
                  <StyledLabel className="notification-type" backgroundColor="error_light">
                    <Text size={12} weight={500} color="error">
                      NEW
                    </Text>
                  </StyledLabel>
                ) : null}
                <NotificationItem.Title>{title ?? ''}</NotificationItem.Title>
                <NotificationItem.Date>{createdDate ?? ''}</NotificationItem.Date>
              </NotificationItem>
            </Link>
          )
        })}
      </NotificationList>
    </InfinityScroll>
  )
}

const StyledLink = styled(Link)`
  display: block;
  padding: 0 24px;
`

const ContentContainer = styled(ColumnItem)`
  gap: 8px;
  padding: 16px 0;
  border-bottom: 1px solid ${Color.line};
`
